/* Core & libraries */
import React, { useEffect, useState, useRef } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import { Formik, Field, ErrorMessage } from "formik";

/* Helpers, constants, custom methods, internal libraries */
import { createValidationPolicyYupSchema, simpleMockedApiValidationObj } from "../../resources/validations/validations";

/* Components */
/* Styles */
import styles from "./styles.js"

const Program = () => {
  const formRef = useRef(null);

  const theme = useTheme();
  const classes = styles({ theme });
  const [testSchema, setTestSchema] = useState({});

  useEffect(() => {
    //create custom validations
    // const formValues = formRef.current.values;

    //TODO: api call to get validations //simpleMockedApiValidationObj
    const result = createValidationPolicyYupSchema(simpleMockedApiValidationObj);

    setTestSchema(result)
  }, [])


  const submitForm = (values, setSubmitting) => {
    setSubmitting(false);
  }


  return (
    <div className="program-page">
      Page
      {/*<br />*/}
      {/*<button onClick={ () => console.log(formRef.current.values) }>Get Form Values</button>*/}
      {/*<br />*/}

      {/*<Formik*/}
      {/*  innerRef={formRef}*/}
      {/*  initialValues={{*/}
      {/*    firstname: "",*/}
      {/*    lastname: "",*/}
      {/*  }}*/}
      {/*  validationSchema={testSchema}*/}
      {/*  onSubmit={(values, { setSubmitting, setErrors }) => {*/}
      {/*    submitForm(values, setSubmitting);*/}
      {/*  }}*/}
      {/*>*/}
      {/*  {({*/}
      {/*      values,*/}
      {/*      errors,*/}
      {/*      touched,*/}
      {/*      handleChange,*/}
      {/*      handleBlur,*/}
      {/*      handleSubmit,*/}
      {/*      isSubmitting,*/}
      {/*    }) => (*/}
      {/*    <>*/}
      {/*      <form onSubmit={handleSubmit} className={styles.form}>*/}
      {/*        <Field*/}
      {/*          placeholder={"firstname"}*/}
      {/*          type="firstname"*/}
      {/*          name="firstname"*/}
      {/*          id="firstname"*/}
      {/*          className={*/}
      {/*            errors.firstname && touched.firstname*/}
      {/*              ? "input-error"*/}
      {/*              : null*/}
      {/*          }*/}
      {/*        />*/}
      {/*        <ErrorMessage*/}
      {/*          name="firstname"*/}
      {/*          component="span"*/}
      {/*          className="error"*/}
      {/*        />*/}
      {/*        <Field*/}
      {/*          placeholder={"lastname"}*/}
      {/*          type="lastname"*/}
      {/*          name="lastname"*/}
      {/*          id="lastname"*/}
      {/*          className={*/}
      {/*            errors.lastname && touched.lastname*/}
      {/*              ? "input-error"*/}
      {/*              : null*/}
      {/*          }*/}
      {/*        />*/}
      {/*        <ErrorMessage*/}
      {/*          name="lastname"*/}
      {/*          component="span"*/}
      {/*          className="error"*/}
      {/*        />*/}

      {/*        <button type="submit" disabled={isSubmitting}>*/}
      {/*          Submit data*/}
      {/*        </button>*/}
      {/*      </form>*/}
      {/*    </>*/}
      {/*  )}*/}
      {/*</Formik>*/}
    </div>
  )
}

export default Program;
